module.exports = __webpack_public_path__ + "b6c441bbb8960500f656a6d7a6c1a84d.jpg";